import Icon from '../components/Icon.vue'

Icon.register({"angle-left":{"width":256,"height":512,"paths":[{"d":"M31.7 239L167.7 103C177.1 93.6 192.3 93.6 201.6 103L224.2 125.6C233.6 135 233.6 150.2 224.2 159.5L127.9 256 224.3 352.4C233.7 361.8 233.7 377 224.3 386.3L201.7 409C192.3 418.4 177.1 418.4 167.8 409L31.8 273C22.3 263.6 22.3 248.4 31.7 239z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/angle-left.js
// module id = null
// module chunks = 